// Shared site constants
export const PROFILE = {
    name: "Gilberto Veliz",
    handle: "@gilbertoevelize",
    photo:
        "https://customer-assets.emergentagent.com/job_veliz-ia-developer/artifacts/rcy9w7u3_geve.jpg",
    phone: "8180918465",
    phoneIntl: "+528180918465",
    phoneDisplay: "+52 81 8091 8465",
    city: "Monterrey, Nuevo León, México",
    facebook: "https://www.facebook.com/share/1B3S8yEQWh/",
    linkedin: "https://www.linkedin.com/in/gilbertovelize/",
    whatsapp: (msg = "") =>
        `https://wa.me/528180918465${
            msg ? `?text=${encodeURIComponent(msg)}` : ""
        }`,
};

export const EBOOK = {
    title: "Arquitecto Digital",
    subtitle: "Conviértete en Arquitecto Digital",
    coverImage: "/ebook-cover.jpg",
    pdfUrl:
        "https://customer-assets.emergentagent.com/job_veliz-ia-developer/artifacts/96un01ci_libronewprint_compressed.pdf",
    pdfFilename: "Arquitecto-Digital-Gilberto-Veliz.pdf",
    checkoutUrl: "https://go.hotmart.com/K105561117I",
    provider: "Hotmart",
};
